import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Form,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";

function ErpCreditCardTransactionAndMonthlyPlan() {
  const [columnSettings, setColumnSettings] = useState();
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [firm, setFirm] = useState([]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    } else {
      setFirm([]);
    }
  };

  const [order, setOrder] = useState("");
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    activeTab: "1",
    filter: "",
  });

  const [activeMainTab, setActiveMainTab] = useState("1"); // Varsayılan olarak ilk ana tab aktif
  const [activeSubTab, setActiveSubTab] = useState("1.2"); // Varsayılan olarak ilk alt tab aktif

  const [firmClass, setFirmClass] = useState({});

  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (activeSubTab.slice(-1) !== "1") {
      conditions.push(
        `erpTransferStatusId Eq ${getErpTransferStatusId(activeTab)}`
      );
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const isExportAvailable =
    activeSubTab.slice(-1) === "2" || activeSubTab.slice(-1) === "5";

  useEffect(() => {
    getColumnSettings();
  }, []);

  useEffect(() => {
    if (columnSettings) {
      getTableData();
    }
  }, [order, tableDataQueryOptions, columnSettings]);

  const getColumnSettings = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
    });
  };

  const getTableData = () => {
    setSelectedRowKeys([]);
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    if (activeMainTab === "1") {
      RequestHandler.get(
        `/ErpMonthlyPlan?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });
    } else if(activeMainTab === "2") {
      RequestHandler.get(
        `/ErpCreditCardTransactionEntity?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });
    } else if(activeMainTab === "3") {

      var filter = getFilterQuery();


      RequestHandler.get(
        `/ErpAccountTransaction?$count=true${filter ? `${filter} and` : "&$filter=" } isManualTransaction eq true and transactionProcessTypeValue eq 1 &$skip=${skip}&$top=${take}`
      ).then((response) => {
          if (Array.isArray(response.value)) {
            setTableData({
              data: response.value,
              total: response["@odata.count"],
              loading: false,
            });
          }
        });


      getFirmClasses();

    }
  };

  const getMonthlyPlanColumns = () => [
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDate",
      key: "transactionDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Açıklama",
      dataIndex: "addUserName",
      align: "center",
    },
    {
      title: "Satış Elemanı",
      dataIndex: "salesmanCode",
      align: "center",
    },
    {
      title: "Evrak No",
      dataIndex: "documentNumber",
      align: "center",
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;
        if (erpStatusText === "Successful") {
          erpStatusText = "Başarılı";
        } else if (erpStatusText === "Transferring") {
          erpStatusText = "Aktarılıyor";
        } else if (erpStatusText === "Unsuccessful") {
          erpStatusText = "Başarısız";
        } else if (erpStatusText === "NotTransferred") {
          erpStatusText = "Aktarılmadı";
        }

        return (
          <Tooltip
            title={
              erpStatusText === "Başarısız" ? row.errorMessage : erpStatusText
            }
          >
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    },
  ];

  const getCreditCardTransactionColumns = () => [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 100,
      align: "center",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Banka Hesap Adı",
      dataIndex: "tenantAccountName",
      align: "center",
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Taksit",
      dataIndex: "installmentType",
      render: (value) => {
        {
          return value == 0 ? "Tek Çekim" : "Taksitli İşlem";
        }
      },
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Satış Elemanı",
      dataIndex: "salesmanCode",
      align: "center",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      render: (text, row, index) => (
        <Tooltip placement="topLeft" title={text}>
          <div style={{ whiteSpace: "break-spaces" }}>
            {text?.trim()?.length > 60 ? text.substring(0, 125) + "..." : text}
          </div>
        </Tooltip>
      ),
    },

    {
      title: "Cari",
      dataIndex: "firmId",
      width: "15%",
      render: (data, row, index) => (
        <Select
          allowClear
          showSearch
          placeholder="En az 2 harf giriniz.."
          defaultValue={data &&  data !== '00000000-0000-0000-0000-000000000000' ? data : undefined}
          disabled={!isExportAvailable}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: "50%" }}
          onSearch={onFirmSearch}
          onChange={(value, option) => {
            let rows = [...tableData.data];
            let rowToUpdate = {
              ...row,
              firmId: value,
              firmName: option?.firmName,
              firmBranchNumber: option?.firmBranchNumber,
            };
            rows[index] = rowToUpdate;
            setTableData({ ...tableData, data: rows });
          }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >

          {data && data !== '00000000-0000-0000-0000-000000000000' && (
            <Select.Option
              key={row.firmId}
              value={row.firmId}
              firmName={row.firmName}
              firmBranchNumber={row.firmBranchNumber}
            >
              {row.firmBranchNumber
                ? `${row.firmName} (${row.firmBranchNumber})`
                : row.firmName}
            </Select.Option>
          )}

          {firm
            .filter((item) => item.id != data)
            .map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                firmName={item.name}
                firmBranchNumber={item.firmBranchNumber}
              >
                {item.firmBranchNumber
                  ? `${item.name} (${item.firmBranchNumber})`
                  : item.name}
              </Select.Option>
            ))}
        </Select>
      ),
    },
    {
      title: "Evrak No",
      dataIndex: "documentNumber",
      align: "center",
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;
        if (erpStatusText === "Successful") {
          erpStatusText = "Başarılı";
        } else if (erpStatusText === "Transferring") {
          erpStatusText = "Aktarılıyor";
        } else if (erpStatusText === "Unsuccessful") {
          erpStatusText = "Başarısız";
        } else if (erpStatusText === "NotTransferred") {
          erpStatusText = "Aktarılmadı";
        }

        return (
          <Tooltip
            title={
              erpStatusText === "Başarısız" ? row.errorMessage : erpStatusText
            }
          >
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    },
  ];

  const getCashTransactionColumns = () => [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 100,
      align: "center",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Banka Hesap Adı",
      dataIndex: "tenantAccountName",
      align: "center",
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "İşlem Tipi",
      dataIndex: "manuelTransactionType"
    },
    {
      title: "Evrak No",
      dataIndex: "documentNumber",
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      render: (text, row, index) => (
        <Tooltip placement="topLeft" title={text}>
          <div style={{ whiteSpace: "break-spaces" }}>
            {text?.trim()?.length > 60 ? text.substring(0, 125) + "..." : text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Cari",
      dataIndex: "firmId",
      width: "15%",
      render: (data, row, index) => (
        <Select
          allowClear
          showSearch
          placeholder="En az 2 harf giriniz.."
          defaultValue={data ?? undefined}
          disabled={!isExportAvailable}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: "50%" }}
          onSearch={onFirmSearch}
          onChange={(value, option) => {
            let rows = [...tableData.data];
            let rowToUpdate = {
              ...row,
              firmId: value,
              firmName: option?.firmName,
              firmBranchNumber: option?.firmBranchNumber,
            };
            rows[index] = rowToUpdate;
            setTableData({ ...tableData, data: rows });
          }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {data && (
            <Select.Option
              key={row.firmId}
              value={row.firmId}
              firmName={row.firmName}
              firmBranchNumber={row.firmBranchNumber}
            >
              {row.firmBranchNumber
                ? `${row.firmName} (${row.firmBranchNumber})`
                : row.firmName}
            </Select.Option>
          )}
          {firm
            .filter((item) => item.id != data)
            .map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                firmName={item.name}
                firmBranchNumber={item.firmBranchNumber}
              >
                {item.firmBranchNumber
                  ? `${item.name} (${item.firmBranchNumber})`
                  : item.name}
              </Select.Option>
            ))}
        </Select>
      ),
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;
        if (erpStatusText === "Successful") {
          erpStatusText = "Başarılı";
        } else if (erpStatusText === "Transferring") {
          erpStatusText = "Aktarılıyor";
        } else if (erpStatusText === "Unsuccessful") {
          erpStatusText = "Başarısız";
        } else if (erpStatusText === "NotTransferred") {
          erpStatusText = "Aktarılmadı";
        }

        return (
          <Tooltip
            title={
              erpStatusText === "Başarısız" ? row.errorMessage : erpStatusText
            }
          >
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    },
  ]

  const monthlyPlancolumns = getMonthlyPlanColumns();

  const creditCardTransactionColumns = getCreditCardTransactionColumns();

  const cashTransactionColumns = getCashTransactionColumns();

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (isSuccess) {
      if (activeMainTab === "2") {
        selectedRowsData.map((item) => {
          if (item.firmId === null) {
            item.firmId = "00000000-0000-0000-0000-000000000000";
          }
        });
      }

      if (activeMainTab === "1") {
        RequestHandler.post(
          "/ErpMonthlyPlan/SetSuccessfulTransfer",
          selectedRowsData
        ).then((response) => {
          if (response.success) {
            getTableData();
          }
        });
      } else if(activeMainTab === "2") {
        RequestHandler.post(
          "/ErpCreditCardTransactionEntity/SetSuccessfulTransfer",
          selectedRowsData
        ).then((response) => {
          if (response.success) {
            getTableData();
          }
        });
      }
      else if(activeMainTab === "3") {
        selectedRowsData.forEach((item) => item.firmClassId = firmClass.id);

        RequestHandler.post(
          "/ErpAccountTransaction/SetSuccessfulTransfer",
          selectedRowsData
        ).then((response) => {
          if (response.success) {
            getTableData();
          }
        });
      }
    }
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (activeMainTab === "1") {
      RequestHandler.post(
        "/ErpMonthlyPlan/SetNotTransferredTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    } else if(activeMainTab === "2") {
      RequestHandler.post(
        "/ErpCreditCardTransactionEntity/SetNotTransferredTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
    else if(activeMainTab === "3") {
      RequestHandler.post(
        "/ErpAccountTransaction/SetNotTransferredTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (activeMainTab === "2") {
      if (
        !selectedRowsData.every(
          (row) =>
            row.firmId && row.firmId !== "00000000-0000-0000-0000-000000000000"
        )
      ) {
        notification.error({
          message:
            "Seçili Kredi Kartı İşlemleri içerisinde 'Cari' seçilmemiş kayıtlar var.",
          duration: 3,
        });
        isSuccess = false;
      }
    }

    if (isSuccess) {
      if (activeMainTab === "1") {
        RequestHandler.post("/ErpMonthlyPlan", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            }
          }
        );
      } else if(activeMainTab === "2"){
        RequestHandler.post(
          "/ErpCreditCardTransactionEntity",
          selectedRowsData
        ).then((response) => {
          if (response.success) {
            getTableData();
          }
        });
      }
      else if(activeMainTab === "3") {

        if (
          !selectedRowsData.every(
            (row) =>
              row.firmId &&
              row.firmId !== "00000000-0000-0000-0000-000000000000"
          )
        ) {
          notification.error({
            message:
              "Seçili hesap hareketleri içerisinde 'Cari' seçilmemiş kayıtlar var.",
            duration: 3,
          });
          isSuccess = false;
        }

        if (selectedRowsData.some((row) => !row.tenantAccountErpCode)) {
          notification.error({
            message:
              "Seçili hesap hareketleri içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
            duration: 3,
          });
          isSuccess = false;
        }


        if(isSuccess) {
          selectedRowsData.forEach((item) => item.firmClassId = firmClass.id);

          RequestHandler.post(
            "/ErpAccountTransaction",
            selectedRowsData
          ).then((response) => {
            if (response.success) {
              getTableData();
            } else {
              isSuccess = false;
            }
          });
        }

        
      }
    }
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });

    setActiveMainTab(tabKey.slice(0, 1));
    setActiveSubTab(tabKey === "1" ? "1.2" : tabKey === "2" ? "2.2" : tabKey === "3" ? "3.2" : tabKey);
  };

  function getErpTransferStatusId(value) {

    if(!value.includes(".")) {
      return 0;
    }
    else {
      switch (value.slice(-1)) {
        case "2":
          return 0;
        case "3":
          return 1;
        case "4":
          return 2;
        case "5":
          return 3;
        default:
          return 0;
      }
    }
   
  }

  const getFirmClasses = (value) => {
    RequestHandler.get(
      `/FirmClass?$filter=isErpType Eq true and ErpValue eq '13'&${odata.orderBy("name")}`
    ).then((response) => {
      if(response.value.length >= 1) {
        setFirmClass(response.value[0]);
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 16 : 15}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined />{" "}
            {activeMainTab === "1"
              ? "ÇEK-SENET AKTARIM" :
              activeMainTab === "2" ? "KREDİ KARTI İŞLEMLERİ AKTARIM" : "KASA İŞLEMLERİ AKTARIM"}
          </p>
        </Col>
        <Col
          xs={activeSubTab.slice(-1) === "3" ? 24 : 24}
          md={activeSubTab.slice(-1) === "3" ? 24 : 8}
          lg={activeSubTab.slice(-1) === "3" ? 6 : 4}
          xl={activeSubTab.slice(-1) === "3" ? 8 : 6}
          style={{
            textAlign: "right",
            paddingLeft: "0px",
          }}
        >
          <Popconfirm
            title={
              activeSubTab.slice(-1) === "2" || activeSubTab.slice(-1) === "5"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={
              activeSubTab.slice(-1) === "2" || activeSubTab.slice(-1) === "5"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(activeSubTab.slice(-1) === "2" ||
              activeSubTab.slice(-1) === "3" ||
              activeSubTab.slice(-1) === "5") && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined />{" "}
                {(activeSubTab.slice(-1) === "2" ||
                  activeSubTab.slice(-1) === "5") &&
                  "Aktarıldı Yap"}
                {activeSubTab.slice(-1) === "3" && "Aktarılmadı Yap"}
              </Button>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={activeSubTab.slice(-1) === "3"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      {/* <ErpPosTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      ></ErpPosTransactionTableFilter> */}

      {/* <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs> */}

      <Tabs activeKey={activeMainTab} onChange={onTabChange}>
        <Tabs.TabPane tab="Çek-Senet" key="1">
          <Tabs activeKey={activeSubTab} onChange={onTabChange}>
            <Tabs.TabPane tab="Tümü" key="1.1" />
            <Tabs.TabPane tab="Aktarılmadı" key="1.2" />
            <Tabs.TabPane tab="Başarılı" key="1.3" />
            <Tabs.TabPane tab="Aktarılıyor" key="1.4" />
            <Tabs.TabPane tab="Başarısız" key="1.5" />
          </Tabs>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Kredi Kartı İşlemleri" key="2">
          <Tabs activeKey={activeSubTab} onChange={onTabChange}>
            <Tabs.TabPane tab="Tümü" key="2.1" />
            <Tabs.TabPane tab="Aktarılmadı" key="2.2" />
            <Tabs.TabPane tab="Başarılı" key="2.3" />
            <Tabs.TabPane tab="Aktarılıyor" key="2.4" />
            <Tabs.TabPane tab="Başarısız" key="2.5" />
          </Tabs>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Kasa İşlemleri" key="3">
          <Tabs activeKey={activeSubTab} onChange={onTabChange}>
            <Tabs.TabPane tab="Tümü" key="3.1" />
            <Tabs.TabPane tab="Aktarılmadı" key="3.2" />
            <Tabs.TabPane tab="Başarılı" key="3.3" />
            <Tabs.TabPane tab="Aktarılıyor" key="3.4" />
            <Tabs.TabPane tab="Başarısız" key="3.5" />
          </Tabs>
        </Tabs.TabPane>
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          {activeMainTab === "1" && (
            <Table
              columns={monthlyPlancolumns}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              rowSelection={
                isExportAvailable
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : tableDataQueryOptions.activeTab === "1.3" ||
                    tableDataQueryOptions.activeTab === "2.3"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : undefined
              }
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          )}

          {activeMainTab === "2" && (
            <Table
              columns={creditCardTransactionColumns}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              rowSelection={
                isExportAvailable
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : tableDataQueryOptions.activeTab === "1.3" ||
                    tableDataQueryOptions.activeTab === "2.3"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : undefined
              }
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          )}


          {activeMainTab === "3" && (
            <Table
              columns={cashTransactionColumns}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              rowSelection={
                isExportAvailable
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : tableDataQueryOptions.activeTab === "1.3" ||
                    tableDataQueryOptions.activeTab === "2.3" || tableDataQueryOptions.activeTab === "3.3"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : undefined
              }
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          )}
        </Col>
      </Row>
    </>
  );
}

export default ErpCreditCardTransactionAndMonthlyPlan;
